(function() {
    'use strict';

    angular.module("caffeprint")
        .directive('cpSpinner', cpSpinner);

    cpSpinner.$inject = [];

    function cpSpinner() {

        return {
            restrict: 'E',
            replace: true,
            templateUrl: 'app/caffeprint/directives/spinner/spinner.html',
            scope: {
                visible: '=',
                inline: '<?'
            },
            link: function(scope, element, attrs, controller) {}
        };
    }
})();
